import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import './styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
